// @flow
const succ = n => n + 1;
const add15 = n => n + 15;

const padLeft = (value, padder, padLength) =>
    Array(padLength)
        .fill(padder)
        .concat(value)
        .join('');

const stringify = n => (n.toString().length === 1 ? padLeft(n, '0', 1) : n.toString());

const sequence = (start, end, nextFn) =>
    start >= end ? [stringify(end)] : [stringify(start), ...sequence(nextFn(start), end, nextFn)];

export const HOURS_RANGE = sequence(0, 23, succ);
export const MINUTES_RANGE = sequence(0, 59, succ);
export const SCHEDULE_RANGE = sequence(0, 45, add15);



// WEBPACK FOOTER //
// ./src/components/widgets/time-spinner/time-units.js